import { Box, Tooltip, Typography, makeStyles } from '@material-ui/core';
import React, {useEffect, useState} from 'react'
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    box1: {
        paddingTop: '15px'
    },
    box2: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    box3: {
        display: 'flex',
        gap: '15px',
        alignItems: 'center',
        minWidth: '300px'
    },
    accountBox: {
        display: 'flex',
        justifyContent: 'space-between'
    }
    , acctName: {
        fontWeight: 'bold',
        fontSize: '15px'
    },
    acctId: {
        fontSize: '15px',
        color: 'gray'
    },
    acctAndCostBox: {
        marginLeft: 'calc(2em + 15px)',
        display: 'flex',
        gap: '15px'
    }
})
export default function AwsAccountCellRenderer(params: any) {
    const styles = useStyles();
    const [isCurrentMonth, setIsCurrentMonth] = useState(false);

    const calculateEstimatedCost = (costTillToday: number, startDate: string, endDate: string) => {
        const today = new Date();
        const firstDay = new Date(startDate);
        const lastDay = new Date(endDate);
        const totalDays = Math.ceil((lastDay.getTime() - firstDay.getTime()) / (1000 * 60 * 60 * 24));
        const costPerDay = parseFloat((costTillToday / totalDays).toFixed(2));
        const totalDaysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        return parseFloat((costPerDay * totalDaysInMonth).toFixed(2));
    };

    const checkIsCurrentMonth = (startDate: string, endDate: string) => {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();

        const start = new Date(startDate);
        const end = new Date(endDate);

        return (
            start.getMonth() === currentMonth && start.getFullYear() === currentYear &&
            end.getMonth() === currentMonth && end.getFullYear() === currentYear
        );
    };

    const { AccountId, AccountName, TotalCost } = params.value;
    const { startDate, endDate } = params.colDef.cellRendererParams;
    const roundedTotalCost = parseFloat(TotalCost).toFixed(2);
    const forecastedCost = parseFloat(calculateEstimatedCost(TotalCost, startDate, endDate)).toFixed(2);

    // Set the state for current month check
    useEffect(() => {
        setIsCurrentMonth(checkIsCurrentMonth(startDate, endDate));
    }, [startDate, endDate]);


    const linkTo = `/resourcecost?accountId=${encodeURIComponent(AccountId)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;


    return (

        <Link to={linkTo}>
            <Box className={styles.box1}>
                <Box>
                    <Box className={styles.box2}>
                        <Box className={styles.box3}>
                            <ViewInArIcon />
                            <Typography variant='body1' className={styles.acctName}>
                                {AccountName}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box>
                    <Box className={styles.accountBox}>
                        <Box className={styles.acctAndCostBox} >
                            <Typography className={styles.acctId} style={{ minWidth: '180px' }}>
                                Account ID: {AccountId}
                            </Typography>
                            <Typography className={styles.acctId}>
                                |
                            </Typography>
                            <Tooltip title='Incurred Cost'>
                                <Typography className={styles.acctId}>
                                    Incurred Cost ($) : {roundedTotalCost}
                                </Typography>
                            </Tooltip>
                            <Typography className={styles.acctId}>                               |
                            </Typography>
                            {
                                isCurrentMonth && <Tooltip title='Forecasted Cost'>
                                <Typography className={styles.acctId}>
                                    Forecasted Cost ($) : {forecastedCost}
                                </Typography>
                            </Tooltip>
                            }
                           
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Link>

    )
}
